import appConfig from '@/config/applicationConfig.js'

export const UserServiceMixim = {
  methods: {
    /**
     * Login request
     * @param {string} userName
     * @param {string} password
     * @returns {Promise}
     */
    loginRequest (userName, password) {
      return this.$http.post(
        `${appConfig.API_END_POINT}/oauth/token`,
        {
          username: userName,
          password: password
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
    },

    /**
    * Get the user data given the bearer token
    */
    getUserData () {
      return this.$http.get(`${appConfig.API_END_POINT}/admin/loggeduser`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.access_token}`
        }
      })
    },

    /**
    * Get the carrier list
    */
    getCarrierData () {
      return this.$http.get(`${appConfig.API_END_POINT}/carriers`, {
        headers: {
          Authorization: `Bearer ${this.$store.state.access_token}`
        }
      })
    },

    logout () {
      this.$session.destroy()
      this.$store.dispatch('logout')
      this.$router.replace('/pages/login')
    }
  }
}
